import { useState, useEffect, useContext, useRef } from 'react';

import LiveReserveSituationCase from './case/LiveReserveSituationCase';

import { LiveReserveSituationType } from '../../../../../../../models/lesson/live/reserve/situation/type/LiveReserveSituationType';


// 内容選択
function LiveReserveSituationModal() {

  // カテゴリ一覧表示(他は閉じる)
  const [openCateKey, setOpenCateKey] = useState<string>('');
  const cateRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  // 開いているカテゴリーが変わったら一番上になるようスクロール
  useEffect(() => {
    const target = cateRefs.current[openCateKey];
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [openCateKey]);


  // 講師にお任せ
  const upToInstructorType: LiveReserveSituationType = {
    groupId: 5,
    title: '講師におまかせ！',
    icon: '/images/page/lesson/live/teacher.png',
    iconAlt: '講師におまかせ！',
  }
  // 初心者におすすめ 
  const biginnerType: LiveReserveSituationType = {
    groupId: 1,
    title: '初心者にオススメ！',
    icon: '/images/common/beginner.png',
    iconAlt: '初心者にオススメ！',
  }
  // ベーシック６回パック！
  const basicType: LiveReserveSituationType = {
    groupId: 6,
    title: 'ベーシック６回パック！',
    icon: '/images/page/lesson/live/plane.png',
    iconAlt: 'ベーシック６回パック！',
  }
  // 教材理解を深めたい方に！
  const understandType: LiveReserveSituationType = {
    groupId: 3,
    title: (
      <>
        教材理解を深めたい方に！
        <br className="visible-xs" />
        （教材をお持ちの方向け）
      </>
    ),
    icon: '/images/common/kyozai.png',
    iconAlt: '教材アイコン',
  }
  // 会話力UPならこちら！
  const speakingType: LiveReserveSituationType = {
    groupId: 4,
    title: (
      <>
        会話力UPならこちら！
        <br className="visible-xs" />
        （プラクティス形式の実践練習）
      </>
    ),
    icon: '/images/common/kaiwa.png',
    iconAlt: '会話力UPならこちら！',
  }


  return (
    <div style={{backgroundColor: '#fff'}}>

      {/* 講師にお任せ */}
      <LiveReserveSituationCase
        type={upToInstructorType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* 初心者におすすめ */}
      <LiveReserveSituationCase
        type={biginnerType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* ベーシック６回パック！ */}
      <LiveReserveSituationCase
        type={basicType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* 教材理解を深めたい方に！ */}
      <LiveReserveSituationCase
        type={understandType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

      {/* 会話力UPならこちら！ */}
      <LiveReserveSituationCase
        type={speakingType}
        openCateKey={openCateKey}
        setOpenCateKey={setOpenCateKey}
        cateRefs={cateRefs}
      />

    </div>
  );
}
  
export default LiveReserveSituationModal;